import { create } from 'zustand';

import { ModalTypes } from '@/widgets/modals/config';

export interface EventModalPayload {
  slug: string;
  title: string;
  startAt: string;
  location: string;
  price: number;
}

interface ModalPayload {
  event?: EventModalPayload;
}

interface ModalStore {
  modal: ModalTypes | null;
  payload: ModalPayload | null;
  openModal: (name: ModalTypes, payload?: ModalPayload) => void;
  closeModal: () => void;
}

export const useModalStore = create<ModalStore>((set) => ({
  modal: null,
  payload: null,
  openModal: (name, payload) => set({ modal: name, payload: payload ?? null }),
  closeModal: () => set({ modal: null, payload: null }),
}));
